import { BitkitNoteCard } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';

import MarkdownBlock from '@/components/MarkdownBlock';
import BuildStatus from '@/models/BuildStatus';

import useBuildDetailsPageStore from '../../BuildDetailsPage.store';
import useBuildAnnotations, { isValidStatus, Status } from './hooks/useBuildAnnotations';

// `annotation.style` arrives verbatim from the build annotation API, which still speaks v1's
// status names, so the rename has to happen here rather than at the source type.
const NOTE_CARD_STATUS: Record<Status, 'critical' | 'info' | 'success' | 'warning'> = {
  error: 'critical',
  info: 'info',
  success: 'success',
  warning: 'warning',
};

const BuildAnnotations = () => {
  const build = useBuildDetailsPageStore((state) => state.build);
  const annotations = useBuildAnnotations({ slug: build.slug, inProgress: build.status === BuildStatus.Running });
  if (annotations.length === 0) {
    return null;
  }
  return (
    <Box display="flex" flexDirection="column" gap="16">
      {annotations.map((annotation) => {
        let style: Status;
        if (isValidStatus(annotation.style)) {
          style = annotation.style;
        } else {
          style = 'info';
        }
        return (
          <BitkitNoteCard
            key={annotation.id}
            status={NOTE_CARD_STATUS[style]}
            message={<MarkdownBlock md={annotation.markdown} />}
          />
        );
      })}
    </Box>
  );
};

export default BuildAnnotations;
